

export class Organization {
    public organization = {
    'active': true ,
    'avatar': '',
    'company': {
        'avatarUrl': '',
        'companyName': '',
        'companyId': '',
        'companyType': '',
        'parentCompany': {
            'id': '',
            'name': '',
            'companyId': ''
        },
        'soa': '',
        'companyLevel': '',
        'countryOfReference' : '',
        'cityOfReference' : '',
        'lastEditedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'lastValidatedBy': {
            'name': '',
            'id': 'String',
            'time': ''
        },
        'validated': '2'
    },
    'companyLeaderShip': {
        'companyLeader': {
            'id': '',
            'name': '',
            'groupId': ''
        },
        'hrLeader': {
            'id': '',
            'name': '',
            'groupId': ''
        },
        'financeLeader': {
            'id': '',
            'name': '',
            'groupId': ''
        },
        'digitalLeader': {
            'id': '',
            'name': '',
            'groupId': ''
        },
        'legalLeader': {
            'id': '',
            'name': '',
            'groupId': ''
        },
        'itLeader': {
            'id': '',
            'name': '',
            'groupId': ''
        },
        'marketingLeader': {
            'id': '',
            'name': '',
            'groupId': ''
        },
        supplyChainLeader: {
            id:  '' ,
            name: '' ,
            groupId: '' ,
        },
        categoryManager: {
            id:  '' ,
            name: '' ,
            groupId: '' ,
        },
        complianceOfficer: {
            id:  '' ,
            name: '' ,
            groupId: '' ,
        },
        'lastEditedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'lastValidatedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'validated': '2'
    },
    'companyOverview': {
        'industrySegment': '',
        'customerTypes': '',
        'marketsServed': '',
        'latestAnnualSales': '',
        'financialRevenue': '',
        'annualProfit': '',
        'businessModel': [],
        'lastEditedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'lastValidatedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'validated': '2'
    },
    'lastEdited': [{
        'name': '',
        'id': '',
        'time': ''
    }],
    'companySize': {
        'joinDate': '',
        'totalSales': '',
        'customerSales': {
            'installers': '',
            'industry': '',
            'infrastructure': '',
            'others': ''
        },
        'productSales' : {
            'cablesAndWires': '',
            'industrialAutomation': '',
            'infrastructure': '',
            'buildingAutomationAndConstruction': '',
            'lighting': '',
            'hvacAndRenewableEnergy': '',
            'safetyToolsAndEngineeringSupplies': '',
            'specialities': '',
            'others': ''
        },
        'employees': '',
        'suppliers': '',
        'customers': '',
        'lastEditedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'lastValidatedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'validated': '2'
    },
    'organogram': [],
    'validated': '2',
    'legalEntities': [],
    'legalEntitiesValidation': {
        'validated': 2,
        'lastValidatedBy': {
            'name': '',
            'id': '',
            'time': ''
        }
    },
    'lastArchivedBy': {
        'name': '',
        'id': '',
        'time': ''
    },
    'lastArchived': [{
        'name': '',
        'id': '',
        'time': ''
    }],
    'sites': [],
    'sitesValidation': {
        'validated': 2,
        'lastValidatedBy': {
            'name': '',
            'id': '',
            'time': ''
        }
    },
}; }
